export const routePaths = {
  root: "/",
  auth: "/auth",
  authChildren: {
    signIn: "/login",
    forgottenPassword: "/forgot-password",
    resetPassword: "/reset-password",
    verifyEmail: "/verif-email",
  },
  members: "/members",
  membersChildren: {
    dashboard: "/profile-tableau-de-bord",
    profileManagement: "/profiles-management",
    profileBanishment: "/profiles-banishment",
    waitingProfile: "/waiting-profile",
    subscription: "/subscriptions-management",
    unsubscription: "/unsubscription-management",
    accountsHistory: "/accounts-history",
    reportManagement: "/report-management",
    warningManagement: "/warning-management",
    reports: "/reports",
    memberData: "/member-data",
  },
  communications: "/communications",
  communicationChildren: {
    news: "/conversations/news",
    newsOpenConversations: "/conversations/news-open-conversations",
  },
  conversations: "/conversations",
  conversationsChildren: {
    exchangeProgress: "/exchange-progress",
    moderation: "/moderation",
    mouqabala: "/mouqabala",
  },
  mouqabala: "/mouqabala",
  mouqabalaChildren: {
    listMouqabala: "/list-mouqabala",
    appointmentSlots: "/slots",
  },

  staffManagement: "/staff-management",
  staffManagementChildren: {
    team: "/team",
    teamMember: "/team/:idMember",
    teamMemberCategory: "/team/:idMember/:category",
    teamMemberStatsCategory: "/team/:idMember/:category",
    stakeholder: "/stakeholder",
    imamSpeakers: "/imam-speakers",
  },
  imamQR: "/imam-faq",
  live: "/live",
  parameters: "/parameters",
  parametersChildren: {
    interface: "/interface",
    moderation: "/moderation-availabilities",
    origins: "/origins",
    nationalities: "/nationalities",
    ethnicities: "/ethnicities",
    plans: "/plans",
    bodyShapes: "/corpulences",
    paidService: "/services",
    cgu: "/cgu",
    sponsoringPlan: "/plan-sponsoring",
  },
};
